import React, { Component } from 'react';
import styled from 'styled-components'
import {Redirect} from 'react-router-dom'

import Video from 'components/Video'
import VideoWrapper from 'components/VideoWrapper'

import Img from 'shared/Img'
import PageWrapper from 'shared/PageWrapper'
import Flex from 'shared/Flex'
import FlexItem from 'shared/FlexItem'
import Link from 'shared/Link'
import Div from 'shared/Div'

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dist: '400px'
    }
  }
  componentDidMount() {
    window.addEventListener('mousemove', this.getMouseDist)
  }
  componentWillUnmount(){
    window.removeEventListener('mousemove', this.getMouseDist)
  }
  getMouseDist = (e) => {
    let startingTop = window.innerHeight/2
    let startingLeft = window.innerWidth/2
    let math = Math.round(Math.sqrt(Math.pow(startingTop - e.clientY, 2) +
                                    Math.pow(startingLeft - e.clientX, 2))/9) + 'px';
    this.setState({
      dist: math
    })
  }

  // playVideo = () => {
  //   if (this.video1 && this.video2 && this.video1.currentTime == 0) {
  //     this.video1.play()
  //     this.video2.play()
  //   }
  //   else {
  //     this.props.history.push('/collections/SS18')
  //   }
  // }
  render() {

    // var url = new URL(this.props.location.url);
    let experiment = this.props.location.search.indexOf('experiment') > -1

    return (
      <main style={{maxHeight: '100vh', overflow: "hidden"}}>
        {<Redirect to='/collections'/>}
        <Flex center fixed height="100%" width="100%">
          <Link to="/collections" style={{cursor: 'pointer'}}>
            <Img animate style={{filter: 'invert(100%)', position: 'relative', left: '4px'}} width="300px" maxWidth="40vw" src="https://s3.amazonaws.com/aez-project/barragan/logo_800.png" alt="Barragan Logo" />
          </Link>
        </Flex>

{

  // <Flex center zIndex={-1} minHeight="100vh" style={{cursor: 'pointer', mixBlendMode: 'exclusion'}}>
  //   <FlexItem height="120vh" top="-10vh" zIndex={-1} >
  //     <Flex center height="100%" >
  //   <Video innerRef={ref => this.video1 = ref} preload autoPlay loop playsInline experiment>
  //     <source src="https://s3.amazonaws.com/aez-project/barragan/runway1.mp4" type="video/mp4" />
  //     Your browser does not support the video tag.
  //   </Video>
  //   </Flex>
  // </FlexItem>
  // </Flex>


}

        {
          // <Flex onClick={() => this.playVideo()} center zIndex={-1} minHeight="100vh" style={{cursor: 'pointer', mixBlendMode: experiment ? 'exclusion' : 'none'}}>
          //   <FlexItem height="120vh" top="-10vh" zIndex={-1} >
          //     <Flex center height="100%" >
          //   <Video innerRef={ref => this.video1 = ref} preload autoPlay loop playsInline experiment={experiment ? this.state.dist : false}>
          //     <source src="https://s3.amazonaws.com/aez-project/barragan/runway1.mp4" type="video/mp4" />
          //     Your browser does not support the video tag.
          //   </Video>
          //   </Flex>
          //   </FlexItem>
          //   <FlexItem height="120vh" top="-10vh" zIndex={-1} >
          //     <Flex center height="100%">
          //   <Video innerRef={ref => this.video2 = ref} preload autoPlay loop playsInline experiment={experiment ? this.state.dist : false}>
          //     <source src="https://s3.amazonaws.com/aez-project/barragan/runway2.mp4" type="video/mp4" />
          //     Your browser does not support the video tag.
          //   </Video>
          // </Flex>

                    // </FlexItem>

                            // </Flex>
        }

      </main>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home.js